<template>
  <div class="header">
    <div class="header-main">
      <div class="w-100 d-flex justify-content-between">
        <div class="d-flex flex-row align-items-center text-center px-0">
          <div class="nav-mobile">
            <div class="nav-mobile__hamburger" id="nav_hambuger">
              <img id="nav_hambuger_icon" src="../../assets/images/icon_hamburger.svg" />
            </div>
            <!-- nav mobile -->
            <div class="nav-mobile__body" :class="{'is-active': isActiveNav}" v-click-outside="toggleNavMobile">
              <div>
                <!-- top -->
                <div class="nav-mobile__top" v-if="pageTitle || hubId">
                  <div class="hub-name">{{ pageTitle }}</div>
                  <div class="hub-id">ID:{{ hubId }}</div>
                </div>
                <!-- main -->
                <div class="nav-mobile__main">
                  <!-- btn select robot -->
                  <!-- <dropdown-custom
                  id="dropdownAppSelect"
                  :right="false"
                  :dropdownGroup="true"
                  >
                    <template v-slot:buttonContent>
                      <div class="dropdown-content-user-action">
                        <img width="32" height="32" :src="require(`../../assets/images/${appSelected.icon}`)" class="rounded-circle"/>
                        <span>{{appSelected.nameApp}}</span>
                      </div>
                    </template>
                    <template v-slot:dropdownItems>
                      <dropdown-group-custom @clickDropdownGroup="onClickRoute($event, 'Dashboard')" groupName="仕分け" groupContent="t-Sort仕分け" :dropdownDivider="true"/>
                      <dropdown-group-custom @clickDropdownGroup="onClickRoute($event, 'RoboHiDashboard')" groupName="CarriRo搬送" groupContent="Robo-HI"/>
                    </template>
                  </dropdown-custom> -->
                  <div class="t-sort-label">
                    <img width="32" height="32" :src="require(`../../assets/images/${appSelected.icon}`)"/>
                    <span>{{appSelected.nameApp}}</span>
                  </div>
                  <!-- group nav -->
                  <div class="group-nav">
                    <!-- item -->
                    <div
                    class="group-nav__item"
                    :class="{'is-active': appSelected.routeName === this.$store.getters.getMenuActive}"
                    @click="onClickRoute($event, appSelected.routeName)">
                      <div class="icon">
                        <img src="../../assets/images/icon_menu_dashboard.svg">
                      </div>
                      <div class="text" v-if="isNotRoboHi">ダッシュボード</div>
                      <div class="text" v-if="isNotTSort">Robo-HI</div>
                    <!-- item  -->
                    </div>
                    <div v-if="isNotRoboHi">
                      <!-- Batch Icon -->
                      <div v-if="!isWorkedGroup" class="group-nav__item" :class="{'is-active': this.$store.getters.getMenuActive === 'Work'}" @click="onClickRoute($event, 'Work')">
                        <div class="icon">
                          <img src="../../assets/images/icon_menu_manager.svg">
                        </div>
                        <div class="text">作業管理</div>
                      </div>
                      <!-- RCS Icon -->
                      <div class="group-nav__item" @click="onClickRoute($event, 'WebRcs')">
                        <div class="icon">
                          <img src="../../assets/images/icon_directions_car.svg">
                        </div>
                        <div class="text">ロボット管理</div>
                      </div>
                    </div>
                  </div>
                  <!-- group nav -->
                  <div class="group-nav" v-if="isNotRoboHi">
                    <div class="group-nav__head">システム設定</div>
                    <!-- item -->
                    <div v-if="!isMasterGroup" class="group-nav__item" :class="{'is-active': this.$store.getters.getMenuActive === 'Master'}" @click="onClickRoute($event, 'Master')">
                      <div class="icon justify-content-end">
                        <img src="../../assets/images/icon_menu_arrow_right.svg">
                      </div>
                      <div class="text">マスタ</div>
                    </div>
                    <!-- item -->
                    <div v-if="mstMenu.CsvUpload" class="group-nav__item" :class="{'is-active': this.$store.getters.getMenuActive === 'CsvUpload'}" @click="onClickRoute($event, 'CsvUpload')">
                      <div class="icon justify-content-end">
                        <img src="../../assets/images/icon_menu_arrow_right.svg">
                      </div>
                      <div class="text">アップロード</div>
                    </div>
                    <!-- item -->
                    <div v-if="mstMenu.TaskTypeSetting" class="group-nav__item" :class="{'is-active': this.$store.getters.getMenuActive === 'TaskTypeSetting'}" @click="onClickRoute($event, 'TaskTypeSetting')">
                      <div class="icon justify-content-end">
                        <img src="../../assets/images/icon_menu_arrow_right.svg">
                      </div>
                      <div class="text">t-Sort仕分けの設定</div>
                    </div>
                    <!-- item -->
                    <div v-if="getDevSettingMode" class="group-nav__item" :class="{'is-active': this.$store.getters.getMenuActive === 'DevSetting'}" @click="onClickRoute($event, 'DevSetting')">
                      <div class="icon justify-content-end">
                        <img src="../../assets/images/icon_menu_arrow_right.svg">
                      </div>
                      <div class="text">開発者設定</div>
                    </div>
                    <!-- item -->
                    <div v-if="mstMenu.LogInformation" class="group-nav__item" :class="{'is-active': this.$store.getters.getMenuActive === 'LogInformation'}" @click="onClickRoute($event, 'LogInformation')">
                      <div class="icon">
                        <img src="../../assets/images/icon_menu_log.svg">
                      </div>
                      <div class="text">ログ</div>
                    </div>
                  </div>
                  <hr>
                  <!-- group nav -->
                  <div class="group-nav">
                    <div class="group-nav__head">全アプリ共通設定</div>
                    <!-- item -->
                    <div v-if="mstMenu.GeneralSetting" class="group-nav__item" :class="{'is-active': this.$store.getters.getMenuActive === 'GeneralSetting'}" @click="onClickRoute($event, 'GeneralSetting')">
                      <div class="icon justify-content-end">
                        <img src="../../assets/images/icon_menu_setting.svg">
                      </div>
                      <div class="text">全体設定</div>
                    </div>
                  </div>
                  <!-- group nav -->
                  <div class="group-nav">
                    <!-- item -->
                    <div v-if="isNotRoboHi" class="group-nav__item" @click="toggleSettingWizard">
                      <div class="icon justify-content-end">
                        <img src="../../assets/images/icon_menu_setting.svg">
                      </div>
                      <div class="text">セットアップ</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- bot -->
              <div class="nav-mobile__bot">
                <!-- info version -->
                  <div class="group-info" @click="onClickAppVersion">
                    <p>Version</p>
                    <p>{{ version }}</p>
                  </div>
                  <div class="logo-help d-flex justify-content-between align-items-center">
                    <div class="logo-black">
                      <img src="../../assets/images/logo/logo_black.svg">
                    </div>
                    <!-- <div class="help">
                      <img src="../../assets/images/icon_help.svg">
                    </div> -->
                  </div>
                  <div class="copy-right">© +Automation Inc. All Rights Reserved.</div>
              </div>
            </div>
          </div>
          <div class="robot-info d-flex align-items-center">
            <div class="robot-info__icon"><img width="32" height="32" :src="require(`../../assets/images/${appSelected.icon}`)" class="rounded-circle"/></div>
            <div class="robot-info__name">{{appSelected.nameApp}}</div>
          </div>
        </div>
        <div
          class="d-flex flex-row justify-content-end align-items-center" id="header-right-section"
        >
        <div class="user-site d-flex mx-1" @click="goToUserSite">
          <span class="d-flex align-items-center material-symbols-outlined">quiz</span>
          <span>ヘルプページ</span>
        </div>
          <dropdown-custom
          v-if="authMode"
          id="dropdownMenuUser"
          class="user-menu mx-1"
          :customClass="[
            (this.$store.getters.getMenuActive === 'UserInfo')
              | (this.$store.getters.getMenuActive === 'Change Password')
              ? 'active'
              : ''
          ]"
          @onClickOutSide="hideDropdownMenuUser">
            <template v-slot:buttonContent>
              <span class="user-menu-button">
                <b-img v-show="getUserAvatar" :src="getUserAvatar" alt="Avatar" class="rounded-circle avatar" />
                <tooltip-component ref="userMenuLabelRef" id="user-menu-label" className="user-menu-label" :imageFlag="false" :title="user ? user.nickName : ''" :placement="'bottom'" />
              </span>
            </template>
            <template v-slot:dropdownItems>
              <dropdown-item-custom @clickDropdownItem="goToHubAccount" dropdownItemName="アカウント一覧"
                :dropdownDivider="true" v-if="isEntraLogin"/>
              <dropdown-item-custom @clickDropdownItem="onClickRoute($event, 'UserManagement')" dropdownItemName="スキャンユーザー一覧"
                :dropdownDivider="true" />
              <dropdown-item-custom @clickDropdownItem="isEntraLogin ? goToHubAccount(true) : onClickRoute($event, 'UserInfo')" dropdownItemName="マイアカウント"
                :dropdownDivider="true" />
              <dropdown-item-custom @clickDropdownItem="onClickRoute($event, 'Change Password')"
                dropdownItemName="パスワード" :dropdownDivider="true"  v-if="!isEntraLogin"/>
              <dropdown-item-custom @clickDropdownItem="onClickLogout" dropdownItemName="ログアウト" />
            </template>
        </dropdown-custom>
        <tooltip-component id="hub-name-label" ref="hubNameLabelRef" className="hub-name-label" :title="hubName" :imageFlag="false" :placement="'bottom'" />
        <div class="logo cursor-pointer pr-1" @click="onClickNavigateToRoute($event, 'Dashboard')"></div>
        </div>
      </div>
    </div>
    <div class="header-line"></div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import RouterUtils from '../../_helpers/router.util'
import { buildMenuList, appSelectedInfo } from '../../common/filter-menu'
import AppConstants from '../../constants/app.constants'
import { plusHubService } from '../../_services/plus-hub.service'
import {store} from '../../store'
import HTTPClient from '../../common/http-client'
import TooltipComponent from '../custom-components/TooltipComponent.vue'
const REGEX_RELEASE_BASE_FIX00 = /(.*)-release_base_(.*)fix00.*/
const REGEX_RELEASE_BASE_NOT_FIX00 = /(.*)-release_base_(.*)/
const REGEX_RELEASE = /([^_]+)_(.*)/
const RELEASE = 'release_'
// 開発設定画面を切り替えるクリック数
const DEV_SETTING_TOGGLE_CLICK_COUNT = 4
// ユーザーアバターの幅
const USER_AVATAR_WIDTH = 24
// 矢印アイコンの幅
const ARROW_ICON_WIDTH = 16
// テキストの最小幅
const TEXT_LABEL_MIN_WIDTH = 60
// ユーザードロップダウンのパディング
const USER_DROPDOWN_PADDING = 16
// ユーザーのニックネームとハブ名にツールチップと省略記号を適用するための最小スクロール幅
const MIN_SCROLL_WIDTH_TO_SHOW_ELLIPSIS = 60
export default {
  data() {
    return {
      pageTitle: null,
      settingSerialId: null,
      isMappedGroup: false,
      isMasterGroup: false,
      isWorkedGroup: false,
      isSettingGroup: false,
      isActiveNav: false,
      mstMenu: AppConstants.MST_MENU,
      // eslint-disable-next-line no-undef
      authMode: config.AUTH_MODE,
      hubId: null,
      hubName: null,
      version: process.env.VERSION,
      appVersionClickCount: 0,
      appVersionClickCountTimer: null,
      isEntraLogin:
          sessionStorage.getItem(AppConstants.STORAGE_LOGIN_MODE) === AppConstants.SYSTEM_LOGIN_MODE
            ? false
            : localStorage.getItem(AppConstants.STORAGE_LOGIN_MODE) === AppConstants.ENTRA_LOGIN_MODE
    }
  },
  components: {
    TooltipComponent
  },
  async created() {
    this.$grobalListener.$on('getHeaderTitle', () => this.$_fetch_setting())
    this.$_fetch_setting()
    this.getPath()
    if (this.authMode) {
      this.$_fetch_hubInfo()
    }

    const currentTime = this.$moment().format('x')
    const dataRes = await HTTPClient.getInstance().httpStatic.get(`VERSION?t=${currentTime}`)
    if (dataRes && dataRes.data) {
      this.version = dataRes.data
    }
    this.getVersion()
  },
  watch: {
    user() {
      // setHubAndUserDropdownWidth() メソッドで使用するユーザー ニックネーム ラベルの最新のスクロール幅を取得するために、ヘッダー コンポーネントを強制的に更新します。
      this.$forceUpdate()
    }
  },
  computed: {
    ...mapState('auth', ['status', 'user']),
    ...mapState('subMenus', ['_pageTitle', '_subMenus']),
    ...mapGetters('auth', ['getUserAvatar']),
    ...mapGetters('devSettingStore', ['getDevSettingMode']),
    isNotRoboHi() {
      return store.getters.getWorkMode !== AppConstants.WORK_MODE_RO_BO_HI
    },
    isNotTSort() {
      return store.getters.getWorkMode !== AppConstants.WORK_MODE_T_SORT
    },
    appSelected() {
      return appSelectedInfo(store.getters.getWorkMode)
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('subMenus', ['addChildrenRoute']),
    ...mapActions('dashboard', ['updateDashboardStorage']),
    ...mapActions('settingWizardStore', ['updateMenuStatus']),
    ...mapActions('devSettingStore', ['updateDevSettingMode']),
    ...mapGetters('setting', ['getSetting']),
    async onClickLogout() {
      await this.logout()
      await this.$router.push('/login')

      // ログアウト時にダッシュボード画面でデータストレージをリセットします。
      const emptyObj = {
        zoomValue: {},
        chuteInfoDisplay: 0,
        chuteLayer: 0
      }
      this.updateDashboardStorage(emptyObj)
    },
    /**
     * 設定データ取得
     */
    async $_fetch_setting() {
      try {
        const results = await this.getSetting()
        this.hubName = results.data.mstSetting.isName
        this.settingSerialId = results.data.mstSetting.settingSerialId
        for (let i = 0; i <= results.data.mstMenu.length; i++) {
          this.mstMenu[results.data.mstMenu[i].menuNo] =
            results.data.mstMenu[i].visible === 1
        }
      } catch (err) {}
      this.isDisableMenu(this.mstMenu)
    },
    getPath() {
      try {
        let pageGroupName = null
        if (this.$route.path.length > 1) {
          const paths = this.$route.path.replace('/', '').split('/')
          pageGroupName = paths.shift()
        }
        return pageGroupName
      } catch (e) {
        console.log(e)
      }
    },
    // ハブ情報データを取得する
    async $_fetch_hubInfo() {
      const res = await plusHubService.getHubInfo()
      if (res && res.data) {
        if (res.data.hubId) {
          this.hubId = res.data.hubId
        }
        if (res.data.hubName) {
          this.pageTitle = res.data.hubName
        }
      }
    },

    /**
     * 指定されたルート名に遷移します
     *
     * @param {Event} e - クリックイベントオブジェクト
     * @param {string} routeName - 遷移先のルート名
     */
    onClickNavigateToRoute(e, routeName) {
      e.preventDefault()
      RouterUtils.goToRouterName(routeName)
    },
    onClickRoute(e, routeName) {
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      this.hideDropdownMenuConfig()
      this.hideDropdownMenuUser()
      RouterUtils.goToRouterName(routeName)
      this.isActiveNav = false
    },
    // Check disabled item menu for header
    isDisableMenu(mstMenu) {
      const listMenu = buildMenuList(mstMenu)
      for (let key in listMenu) {
        const keyObject = Object.keys(listMenu[key])[0]
        const value = Object.values(listMenu[key])[0]
        const checkValueShow = value.every(e => e === false)
        switch (keyObject) {
          case 'Master':
            this.isMasterGroup = checkValueShow
            break
          case 'Mapping':
            this.isMappedGroup = checkValueShow
            break
          case 'Work':
            this.isWorkedGroup = checkValueShow
            break
          case 'Setting':
            this.isSettingGroup = checkValueShow
            break
          default:
            break
        }
      }
    },
    hideDropdownMenuConfig() {
      if (this.$refs.dropDownMenuConfig) {
        this.$refs.dropDownMenuConfig.hide()
      }
    },
    hideDropdownMenuUser() {
      if (this.$refs.dropdownMenuUser) {
        this.$refs.dropdownMenuUser.hide()
      }
    },
    toggleNavMobile(e) {
      if (e.target.id === 'nav_hambuger' || e.target.id === 'nav_hambuger_icon') {
        this.isActiveNav = !this.isActiveNav
      } else {
        this.isActiveNav = false
      }
    },
    /**
     * トグル設定ウィザードパネル。
     */
    toggleSettingWizard() {
      this.isActiveNav = false
      this.$emit('open-setting-wizard-panel', true)
      this.updateMenuStatus(1)
    },
    getVersion() {
      if (!this.version) {
        return
      }

      const releaseBaseFix00RegexResult = this.version.match(REGEX_RELEASE_BASE_FIX00)
      if (releaseBaseFix00RegexResult) {
        this.version = releaseBaseFix00RegexResult[1]
        return
      }

      const releaseBaseNotFix00RegexResult = this.version.match(REGEX_RELEASE_BASE_NOT_FIX00)
      if (releaseBaseNotFix00RegexResult) {
        this.version = releaseBaseNotFix00RegexResult[1] + ' (' + releaseBaseNotFix00RegexResult[2] + ')'
        return
      }

      if (this.version.includes(RELEASE)) {
        this.version = this.version.replace(RELEASE, '')
        const releaseRegexResult = this.version.match(REGEX_RELEASE)
        if (releaseRegexResult) {
          this.version = releaseRegexResult[1] + ' (' + releaseRegexResult[2] + ')'
        }
      }
    },

    /**
     * ヘッダーメニューの項目開発設定を開いたり閉じたりします。
     */
    onClickAppVersion() {
      this.appVersionClickCount++
      if (this.appVersionClickCount === 1) {
        this.appVersionClickCountTimer = setTimeout(() => {
          this.resetAppVersionTimer()
        }, 3000)
      } else if (this.appVersionClickCount === DEV_SETTING_TOGGLE_CLICK_COUNT) {
        this.resetAppVersionTimer()
        this.getDevSettingMode ? this.updateDevSettingMode(0) : this.updateDevSettingMode(1)
      }
    },
    /**
     * アプリのバージョンタイマーをリセットします。
     */
    resetAppVersionTimer() {
      clearTimeout(this.appVersionClickCountTimer)
      this.appVersionClickCountTimer = null
      this.appVersionClickCount = 0
    },
    /**
     * ユーザーサイトに移動します。
     */
    goToUserSite() {
      let url = AppConstants.USER_SITE_URL
      if (this.isEntraLogin) {
        url += AppConstants.USER_SITE_AZURE_LOGIN_PATH
      }
      window.open(url, '_blank')
    },
    /**
     * Hubアカウントに移動します。
     * @param {boolean} isGotoProfile - プロフィールに移動するかどうか
     */
    goToHubAccount(isGotoProfile = false) {
      let url = AppConstants.HUB_ACCOUNT_BASE_URL
      if (isGotoProfile) {
        url += AppConstants.HUB_ACCOUNT_PROFILE_PATH
      } else {
        url += AppConstants.HUB_ACCOUNT_LIST_PATH
      }
      window.open(url, '_blank')
    },
    /**
     * ツールチップのラベル要素を取得する
     * @param {string} tooltipRef ツールチップのリファレンス
     * @returns ツールチップのラベル要素 (html要素)
     */
    getTooltipLabel(tooltipRef) {
      if (this.$refs[tooltipRef] && this.$refs[tooltipRef].$refs.labelRef) {
        return this.$refs[tooltipRef].$refs.labelRef
      }
      return null
    },
    /**
     * コンテンツに基づいて要素の最小幅を設定します
     */
    setHubAndUserDropdownWidth() {
      if (this.authMode) {
        const userDropdownId = document.getElementById('dropdownMenuUser')
        const userMenuLabelRef = this.getTooltipLabel('userMenuLabelRef')
        if (userDropdownId && userMenuLabelRef) {
          let userDropdownWidth = TEXT_LABEL_MIN_WIDTH + ARROW_ICON_WIDTH + USER_DROPDOWN_PADDING
          if (this.getUserAvatar) {
            userDropdownWidth += USER_AVATAR_WIDTH
          }
          userDropdownId.style.minWidth = 'unset'
          userDropdownId.style.minWidth = userMenuLabelRef.scrollWidth < MIN_SCROLL_WIDTH_TO_SHOW_ELLIPSIS ? 'fit-content' : userDropdownWidth + 'px'
        }
      }
      const hubNameLabelRef = this.getTooltipLabel('hubNameLabelRef')
      if (hubNameLabelRef) {
        hubNameLabelRef.style.minWidth = 'unset'
        hubNameLabelRef.style.minWidth = hubNameLabelRef.scrollWidth < MIN_SCROLL_WIDTH_TO_SHOW_ELLIPSIS ? 'fit-content' : TEXT_LABEL_MIN_WIDTH + 'px'
      }
    }
  },
  updated() {
    this.setHubAndUserDropdownWidth()
  }
}
</script>
<style lang="scss" scoped>
.header {
  .header-main {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: $default-header-height;

    /* Text */
    background: #252422;
    & > div {
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      margin: 0px 0px;
    }

    #header-right-section {
      flex: 1;
      min-width: 0;
      .user-site,.user-management {
        padding: 8px;
        color: white;
        cursor: pointer;
        @include responsive-fs(12);
        font-weight: 400;
        white-space: nowrap;
        .building-icon {
          display: flex;
          align-items: center;
          @include responsive-fs(14);
        }
      }
      .user-site:hover,.user-management:hover {
        background: rgba(255, 255, 255, 0.16);
        border-radius: 80px;
      }
    }
  }
  .nav-mobile {
    &__hamburger {
      padding: 10px;
      margin-left: 9px;
      font-size: 14px;
      cursor: pointer;
    }
    &__body {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: absolute;
      top: $default-header-height;
      left: calc(-1 * (#{$default-hamburger-menu-width} + #{$default-sw-menu-width}));
      width: $default-hamburger-menu-width;
      height: calc(100vh - #{$default-header-height});
      overflow: auto;
      transition: left 0.5s ease-in-out;
      background: #F8F8F8;
      box-shadow: 0px 8px 35px rgba(51, 51, 51, 0.16);
      border-radius: 0px 12px 12px 0px;
      z-index: 99;
      @include media-breakpoint-default() {
        // 15px (height of scroll)
        height: calc(100vh - #{$default-header-height} - 15px);
      }
      &.is-active {
        left: 0;
      }
    }
    &__top {
      padding: 16px;
      text-align: left;
      border-bottom: 1px solid #D6D6D6;
      background-color: #F8F8F8;
      .hub-name {
        font-size: 16px;
        font-weight: 700;
      }
      .hub-id {
        font-size: 14px;
      }
    }
    &__main {
      padding: 16px;
      background-color: #F8F8F8;
      .group-nav {
        margin-bottom: 16px;
        &__head {
          font-size: 12px;
          font-weight: 700;
          color: #666563;
          padding-left: 12px;
          text-align: left;
          margin-bottom: 4px;
        }
        &__item {
          display: flex;
          align-items: center;
          padding: 6px 16px;
          cursor: pointer;
          border-radius: 4px;
          &:hover {
            background: rgba(37, 36, 34, 0.04);
          }
          &.is-active {
            background: rgba(180, 27, 62, 0.08);
          }
          .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            margin-right: 5px;
          }
          .text {
            line-height: 0;
            font-size: 16px;
          }
        }
      }
      hr {
        background-color: #D6D6D6;
        margin-bottom: 16px;
        margin-top: 16px;
        font-size: 16px;
      }
    }
    &__bot {
      background-color: #F8F8F8;
      padding-bottom: 16px;
      .logo-help {
        padding: 0 32px;
        font-size: 12px;
        margin-bottom: 8px;
        height: 24px;
      }
      .copy-right {
        font-size: 12px;
        color: #666563;
        text-align:  center;
      }
      .group-info {
        font-size: 12px;
        color: #666563;
        text-align: left;
        margin-bottom: 16px;
        margin-left: 32px;
        display: flex;
        flex-direction: column;
        max-width: fit-content;
        p {
          margin-bottom: 0;
        }
      }
    }
  }
  .robot-info {
    margin-left: 8px;
    position: relative;
    right: 10px;
    &__icon {
      margin-right: 5px;
      font-size: 24px;
    }
    &__name {
      @include responsive-fs(16);
      font-weight: bold;
      color: #FFFFFF;
      white-space: nowrap;
      @include media-breakpoint-small() {
        @include responsive-fs(12);
        width: 55px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .logo {
    background: url(../../assets/images/logo/logo.svg);
    background-repeat: no-repeat, repeat;
    background-size: 45.06px 20px;
    width: 45.06px;
    height: 20px;
    margin-right: 16px;
    margin-left: 8px;
    flex-shrink: 0;
  }
  .header-line {
    position: static;
    height: $default-header-separator-height;
    left: 0px;
    top: 52px;

    /* Main */
    background: #b41b3e;
  }
  .line {
    width: 1px;
    height: calc(100% - 30px);
    background: #666563;
    margin: 15px 20px;
  }

// #dropdownAppSelect {
//   /deep/ .dropdown-menu {
//     .dropdown-header {
//       font-size: 12px;
//       padding-top: 8px;
//       padding-bottom: 8px;
//     }
//     .line-divider {
//       padding-bottom: 0px !important;
//       margin-top: 8px;
//       margin-bottom: 8px;
//     }
//     .dropdown-item {
//       font-size: 14px;
//       padding-top: 4px;
//       padding-bottom: 4px;
//     }
//   }
// }

  // Boostrap customize
  /deep/ li.nav-item.b-nav-dropdown.dropdown {
    list-style: none;
    > ul > li > a.dropdown-item {
      padding: unset;
      padding-left: 1.5rem;
      width: 100%;
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
      width: 100%;
      display: flex;
      i {
        flex-grow: 1;
      }
    }
    a.nav-link.dropdown-toggle,
    a.nav-link.dropdown-toggle:hover {
      color: white;
    }
    border-radius: 25px;
  }

  li.nav-item.b-nav-dropdown.dropdown:hover {
    background-color: rgba(255, 255, 255, 0.16);
  }
  /deep/ .btn-group > .btn,
  .btn-group-vertical > .btn {
    background-color: inherit;
    border: none;
    border-radius: 80px;
    &:hover {
      background: rgba(255, 255, 255, 0.16);
      border-radius: 80px;
    }
  }
  .header_ttl {
    @include responsive-fs(16, true);
    font-weight: 700 !important;
  }
  .active {
    background-color: gray;
    border-radius: 80px;
  }
  .avatar {
    width: 20px;
    height: 20px;
  }
  .user-menu {
    .user-menu-button {
      display: flex;
      align-items: center;
      @include responsive-fs(12);
      .label {
        margin-left: 2px;
        @include media-breakpoint-default() {
          display: none;
        }
      }
    }
    /deep/ .dropdown-toggle {
      display: flex;
      align-items: center;
      padding-left: 8px;
      padding-right: 8px;
      overflow: hidden;
      &::after {
        margin-left: 6px;
        border-top: 6px solid;
        border-right: 5px solid transparent;
        border-bottom: 0;
        border-left: 5px solid transparent;
      }
    }
    /deep/ .dropdown-menu {
      width: max-content;
      border: 1px solid #D6D6D6;
      box-shadow: 0px 4px 10px rgba(51, 51, 51, 0.12);
      border-radius: 8px;
      li {
        padding-left: 12px!important;
        &:hover {
          background-color: #e9ecef;
        }
        &:first-child {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }
        &:last-child {
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }
        .dropdown-item {
          display: flex;
          align-items: center;
          @include responsive-fs(14);
          padding-left: 4px!important;
          padding: 8px 0!important;
          &:hover {
            background: none!important;;
          }
        }
        .dropdown-divider {
          margin: 0;
        }
      }
    }
  }
  /deep/ .hub-name-label {
    color: white;
    @include responsive-fs(12);
    font-style: normal;
    font-weight: 700;
    line-height: 160%;
    @include textOverflowEllipsis();
  }
  #dropdownMenuUser {
    min-width: 0;
  }
  .user-menu {
    &-button {
      overflow: hidden;
      display: flex;
      align-items: center;
      @include responsive-fs(12);
      &-label {
        margin-left: 2px;
      }
    }
    .avatar {
    width: 20px;
    height: 20px;
    margin-right: 4px;
    }
  }
  /deep/ .user-menu-label {
    @include textOverflowEllipsis();
  }
  // .dropdown-content-user-action {
  //   display: inline-flex;
  //   align-items: center;
  //   img {
  //     margin-right: 8px;
  //   }
  //   span {
  //     font-size: 16px;
  //     font-weight: bold;
  //     color: #252422;
  //   }
  // }
  .t-sort-label {
    display: inline-flex;
    align-items: center;
    text-align: left;
    width: 100%;
    height: 48px;
    padding: 8px;
    margin-bottom: 16px;
    img {
      margin-right: 8px;
    }
    span {
      font-size: 16px;
      font-weight: bold;
      color: #252422;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Header.vue